<template>
  <div class="people d-flex flex-row justify-content-start flex-wrap" v-if="hiringManager.render || recruiter.render">
    <div class="d-flex flex-row align-items-center mb-2 mr-4" v-if="recruiter.render">
      <font-awesome-icon class="text-primary-a5 mr-2" icon="user" :size="iconSize"/>
      <div class="d-flex flex-column">
        <span class="d-block text-secondary-a5" v-if="!hideLabels">{{ $t('jobs.key-stats.recruiter') }}</span>
        <span class="d-block text-secondary-a8" :class="{ 'font-weight-bold': !hideLabels }">
          <font-awesome-icon icon="envelope" /> <a :href="recruiter.email">{{recruiter.name}}</a>
        </span>
      </div>
    </div>
    <div class="d-flex flex-row align-items-center mb-2 mr-4" v-if="hiringManager.render">
      <font-awesome-icon class="text-primary-a5 mr-2" icon="user" :size="iconSize"/>
      <div class="d-flex flex-column">
        <span class="d-block text-secondary-a5" v-if="!hideLabels">{{ $t('jobs.key-stats.hiringManager') }}</span>
        <span class="d-block text-secondary-a8" :class="{ 'font-weight-bold': !hideLabels }">
          <font-awesome-icon icon="envelope" /> <a :href="hiringManager.email">{{hiringManager.name}}, {{hiringManager.title}}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import _isPlainObject from 'lodash/isPlainObject';
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    job: {
      type: Object,
      required: true,
    },
    iconSize: {
      type: String,
      default: '2x',
    },
    includeType: {
      type: Boolean,
      default: false,
    },
    hideLabels: {
      type: Boolean,
      default: false,
    },
    isPublic: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapRoot([ 'company' ]),
    hiringManager() {
      if (this.getCustomValue('hiringManagerName') &&
        this.getCustomValue('hiringManagerTitle') &&
        this.getCustomValue('hiringManagerEmail')) {
        return {
          render: true,
          name: this.getCustomValue('hiringManagerName'),
          title: this.getCustomValue('hiringManagerTitle'),
          email: `mailto:${this.getCustomValue('hiringManagerEmail')}`,
        };
      } else {
        return {
          render: false,
        };
      }
    },
    recruiter() {
      if (this.getCustomValue('recruiterName') &&
        this.getCustomValue('recruiterEmail')) {
        return {
          render: true,
          name: this.getCustomValue('recruiterName'),
          email: `mailto:${this.getCustomValue('recruiterEmail')}`,
        };
      } else {
        return {
          render: false,
        };
      }
    }
  },
  methods: {
    getCustomValue(key) {
      if (this.job && _isPlainObject(this.job.customFieldsHash)) {
        return this.job.customFieldsHash[key] || null;
      } else if (this.job && Array.isArray(this.job.customFields)) {
        return (this.job.customFields.find(cf => cf && cf.key === key) || {}).value;
      } else {
        return null;
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/people.vue